






import { Component, Vue } from "vue-property-decorator";
@Component
export default class Loading extends Vue {
    scale: number = 0.1;
    visible: boolean = false;
    deg: number = 0;
}
